import { Commands } from '../../../vendor_core/core/src/commands/CommandEnum';
import CommandManager from '../../../vendor_core/core/src/commands/CommandManager';
import PointerEvents from '../../../vendor_core/core/src/const/PointerEvents';
import CommManager from '../../../vendor_core/core/src/controllers/CommManager';
import AutoplayModel from '../../../vendor_core/core/src/model/AutoplayModel';
import BetModel from '../../../vendor_core/core/src/model/BetModel';
import GameModel from '../../../vendor_core/core/src/model/GameModel';
import SpinModel from '../../../vendor_core/core/src/model/SpinModel';
import RequestRegister from '../../../vendor_core/core/src/server/requests/RequestRegister';
import { State } from '../../../vendor_core/core/src/states/State';
import UIController from '../../../vendor_core/core/src/ui/UIController';
import { UIModes, UIStates } from '../../../vendor_core/core/src/ui/UIStates';
import { DefaultLayers } from '../../../vendor_core/core/src/utils/Layers';
import Locale from '../../../vendor_core/core/src/utils/Locale';
import ViewManager from '../../../vendor_core/core/src/utils/ViewManager';
import SceneView from '../../../vendor_core/core/src/views/SceneView';
import VendorModel from '../model/VendorModel';
import ReelGroup from '../../core/src/views/ReelGroup';
import App from '../../core/src/App';
import CurrencyUtils from '../../core/src/utils/CurrencyUtils';
import LocalData from '../../core/src/utils/LocalData';
import LocalStorageVars from '../../core/src/const/LocalStorageVars';
import { UIUpdateEvent } from '../../core/src/ui/UIUpdateEvents';

export default class ExitFreeGamesState extends State {
    protected scene: SceneView;
    enter(): void {
        super.enter();

        CommManager.send(RequestRegister.get("getBalance"), (data) => {
            BetModel.update(data);
            UIController.updateFields(UIUpdateEvent.Balance);
        }, this);

        CommandManager.execute(Commands.UPDATE_WIN, VendorModel.freeGames);
        let msgPatternReplace = [];

        ViewManager.getLayer(DefaultLayers.FreegamesCounter).clear();
        ViewManager.getLayer(DefaultLayers.FreespinCounter).clear();

        this.scene = ViewManager.getLayer(DefaultLayers.Popups).setScene("freeGamesExit");
        this.scene.interactive = true;
        this.scene.sceneTextFields.get("title").text = Locale.getString(
            "exit_free_games_title"
        );

        msgPatternReplace.push(
            CurrencyUtils.formatCurrency(
                VendorModel.freeGames?.win / App.config.subUnits,
                BetModel.currencyLocalization
            )
        );

        if (VendorModel.freeGames?.win > 0) {
            this.scene.sceneTextFields.get("text").text =
                Locale.getString("gui_congratulations") +
                "\n" +
                Locale.getString("gui_exit_free_games_data", msgPatternReplace) +
                "\n" +
                (VendorModel.freeGames?.win / 100).toFixed(2);
        } else {
            this.scene.sceneTextFields.get("text").text = Locale.getString(
                "gui_exit_free_games_data_loss",
                msgPatternReplace
            );
        }

        if (VendorModel.hasFreeGamesExpired || VendorModel.hasFreeGamesExpiredDuringFreespins) {
            ReelGroup.instance.stopDefault();
            this.scene.sceneTextFields.get("text").text = 
                Locale.getString("gui_exit_free_games_data_expired") +
                "\n" +
                Locale.getString("gui_exit_free_games_data_expired_p", msgPatternReplace);
            VendorModel.hasFreeGamesExpiredDuringFreespins = false;
            CommandManager.execute(Commands.SAVE_SETTINGS);
        }

        const exitButton = this.scene.buttons.get("exit");

        ViewManager.getLayer("SplashOverlay").setScene("open");

        exitButton.on(PointerEvents.DOWN, () => {
            SpinModel.exitFreegames();
            this.cleanAutoplay();
            GameModel.shouldUpdateBalance = true;
            UIController.setMode(UIModes.DEFAULT);
            UIController.setState(UIStates.IDLE);
            VendorModel.freeGames = null;
            //----set last saved bet before FG----
            BetModel.lastBet = Number(LocalData.getValue(LocalStorageVars.LAST_BET));
            CommandManager.execute(Commands.SET_BET, { 
                coinIndex: BetModel.lastBet, 
                multiplier: undefined, 
                value: BetModel.creditValues[BetModel.lastBet] / App.config.subUnits
            });
            //------------------------------------
            CommManager.send(RequestRegister.get("hasFreeGames"), (data) => {
                // console.log(data);
                VendorModel.update(data);
                this.exit();
            }, this);
        });
    }

    protected cleanAutoplay() {
        AutoplayModel.setAutoSpin(0);
        CommandManager.execute(Commands.CLEAR_AUTOPLAY_LIMITS)
    }
    exit(): void {
        ViewManager.getLayer(DefaultLayers.Popups).clear();
        ViewManager.getLayer("SplashOverlay").clear();
        super.exit();
    }
}
